import React from 'react'
import {
    View,
    TouchableOpacity,
    Text
} from 'react-native'
import moment from 'moment'

export default class DayComponent extends React.PureComponent {

    customStyleDate(date, currentDate) {
        if (date.dateString == currentDate) {
            return {
                backgroundColor: '#FFC20E',
            }
        }
        return {
            backgroundColor: '#fff',
        }

    }

    customStyleTitleDate(date) {
        if (date.dateString < moment().format('YYYY-MM-DD')) {
            return {
                color: 'grey',
            }
        }

        if (date.dateString > moment().endOf('month').add(1, 'M').format('YYYY-MM-DD')) {
            return {
                color: 'grey',
            }
        }


        return {
            color: 'black',
        }

    }

    customStyleTitleDateLunar(date) {
        if (date.dateString < moment().format('YYYY-MM-DD')) {
            return {
                color: 'grey',
            }
        }

        if (date.dateString > moment().endOf('month').add(1, 'M').format('YYYY-MM-DD')) {
            return {
                color: 'grey',
            }
        }

        return {
            color: 'black',
        }

    }

    render() {

        const { lunarDay, lunarMonth, date, currentDate } = this.props;
        console.log('currentDate con', currentDate)
        return (
            <TouchableOpacity
                onPress={() => {
                    this.props.onChooseDate(date);
                }}
                // disabled={date.dateString < moment().format('YYYY-MM-DD')}
                activeOpacity={0.7}
                style={{
                    width: 48,
                    minHeight: 40,
                    borderRadius: 8,
                    padding: 2,

                    ...this.customStyleDate(date, currentDate),
                }}>
                <View style={{
                    alignItems: 'center',
                    // justifyContent: 'center',
                }} >
                    <Text style={{
                        fontSize: 15,
                        ...this.customStyleTitleDate(date),
                    }}>
                        {date.day}
                    </Text>
                </View>
                <View style={{ alignItems: 'flex-end' }}>
                    <Text style={{
                        fontSize: 11,
                        color: 'grey',
                        ...this.customStyleTitleDateLunar(date)
                    }}>
                        {lunarDay} {lunarDay == 1 && `/${lunarMonth}`}
                    </Text>
                </View>

            </TouchableOpacity>
        )
    }
}

